export default __webpack_public_path__ + "static/media/IMG_0111_pp_v2-01.37c43cad.jpg";